var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _path14, _path15, _path16, _path17, _circle, _circle2, _path18, _path19, _path20, _path21, _path22, _path23, _circle3, _g, _path24, _path25, _g2, _path26, _path27, _g3, _path28, _path29, _path30, _path31, _path32, _path33, _g4, _path34, _path35, _path36, _path37, _g5, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _rect2, _path70, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 292,
    viewBox: "0 0 343 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3132 125.381H50.27L18.2939 291.539H16.1621L42.3132 125.381Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2712 125.381H46.2928L24.2988 260.342L50.2712 125.381Z",
    fill: "#232056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5449 124.399C11.5449 123.124 12.5787 122.09 13.8539 122.09H268.135C268.454 122.09 268.712 122.348 268.712 122.667V128.151C268.712 128.47 268.454 128.728 268.135 128.728H13.8539C12.5787 128.728 11.5449 127.695 11.5449 126.419V124.399Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.015 125.223H228.058L260.034 291.381H262.166L236.015 125.223Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.152 195.108V188.064V156.003C156.152 138.394 189.052 138.394 224.256 138.394C225.928 123.469 227.728 89.4416 236.291 86.9866C270.445 77.1948 277.98 88.8971 274.854 114.61C264.824 197.12 253.94 195.108 244.412 195.108H156.152Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.2361,
    height: 84.2794,
    transform: "matrix(-1 0 0 1 206.658 191.938)",
    fill: "#181818"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.658 276.217H197.422L206.658 191.938V276.217Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.539 276.217H197.474C194.956 278.766 188.409 280.806 180.855 281.826C172.797 282.914 166.251 282.846 166.251 291.514H239.273C239.273 282.846 235.245 282.846 223.662 281.826C214.395 281.01 208.386 277.747 206.539 276.217Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.553 118.451H168.27V122.091H125.553V118.451Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.617 120.76H168.334V122.203H125.617V120.76Z",
    fill: "#9B9B9B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.617 118.451H168.334V119.606H125.617V118.451Z",
    fill: "#9B9B9B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2491 73.0075C91.0773 72.1172 91.7594 71.291 92.6661 71.291H123.222C123.913 71.291 124.508 71.7817 124.639 72.4608L133.881 120.373C134.053 121.263 133.371 122.09 132.464 122.09H101.908C101.217 122.09 100.622 121.599 100.491 120.92L91.2491 73.0075Z",
    fill: "#D7D7D7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.909 122.09H133.407C133.825 122.09 134.139 121.709 134.06 121.299C134 120.986 133.726 120.76 133.407 120.76H100.461L100.492 120.92C100.623 121.599 101.217 122.09 101.909 122.09Z",
    fill: "#9B9B9B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.843 119.605L124.641 72.4577C124.508 71.78 123.915 71.291 123.224 71.291H121.865L131.39 119.605H133.843Z",
    fill: "#9B9B9B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.729,
    cy: 94.6857,
    rx: 1.48263,
    ry: 4.18511,
    transform: "rotate(-10.1693 110.729 94.6857)",
    fill: "#9B9B9B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.107 47.3357C152.107 46.5387 151.461 45.8926 150.664 45.8926H118.627C117.83 45.8926 117.183 46.5387 117.183 47.3357V60.0354C117.183 60.8324 117.83 61.4785 118.627 61.4785H146.454C146.923 61.4785 147.362 61.7055 147.632 62.0875L151.583 67.6656C151.746 67.8952 152.107 67.7801 152.107 67.4988V61.4785V47.3357Z",
    fill: "#CCCBEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.49 50.2227H121.802",
    stroke: "white",
    strokeWidth: 0.865884
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.49 53.3965H121.802",
    stroke: "white",
    strokeWidth: 0.865884
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.49 56.5723H121.802",
    stroke: "white",
    strokeWidth: 0.865884
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4877,
    cy: 26.6986,
    r: 20.8627,
    fill: "#CCCBEC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4874,
    cy: 26.6983,
    r: 22.513,
    stroke: "#02005B",
    strokeWidth: 0.288628
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4883 26.4754V16.1562",
    stroke: "#02005B",
    strokeWidth: 0.865884,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 7.63086V10.5471",
    stroke: "#02005B",
    strokeWidth: 0.577256
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4199 26.3633L46.3362 26.3633",
    stroke: "#02005B",
    strokeWidth: 0.577256
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 42.1777V45.094",
    stroke: "#02005B",
    strokeWidth: 0.577256
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9668 26.3633L80.8831 26.3633",
    stroke: "#02005B",
    strokeWidth: 0.577256
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7227 26.4746H62.7115",
    stroke: "#02005B",
    strokeWidth: 0.865884,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.4872,
    cy: 26.7,
    r: 2.46763,
    fill: "#02005B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.762 269.341C170.059 264.523 162.317 251.23 162.317 251.23L183.563 240.963C183.563 240.963 184.016 250.862 187.557 258.923C189.531 263.417 192.459 272.267 192.282 275.651C191.391 281.981 156.633 286.271 161.762 269.341Z",
    fill: "#FFA24C"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.563 240.962C183.563 240.962 184.016 250.861 187.557 258.922C189.531 263.417 192.458 272.267 192.281 275.651C192.211 276.15 191.931 276.636 191.476 277.1C191.461 272.99 189.405 263.662 187.505 261.671C185.605 259.681 185.588 255.469 184.579 256.3C182.125 258.32 172.312 258.922 165.529 261.062C164.559 257.707 162.317 251.23 162.317 251.23L183.563 240.962Z",
    fill: "#CCCBEC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M138.264 285.26C142.971 283.027 153.995 273.736 162.042 269.153C166.464 271.033 167.484 276.343 169.295 278.43C171.107 280.518 172.071 282.015 182.393 279.358C192.714 276.702 191.512 276.082 192.325 275.641C193.138 275.199 194.087 278.438 193.435 278.605C193.141 278.681 183.711 281.557 173.176 283C159.899 287.474 145.913 290.901 143.453 291.47C138.971 292.508 134.605 287.247 138.264 285.26Z",
    fill: "#3C3A82"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.2211 266.069C101.729 266.878 103.04 246.2 103.04 246.2L127.552 255.564C127.552 255.564 122.643 263.939 119.632 272.431C117.991 277.06 116.31 286.124 114.178 288.758C109.439 294.06 81.2935 277.179 92.2211 266.069Z",
    fill: "#FFA24C"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M127.553 255.564C127.553 255.564 122.644 263.939 119.633 272.431C117.992 277.06 116.311 286.123 114.179 288.758C113.667 288.784 113.14 288.786 112.601 288.768C118.077 283.242 116.293 275.351 117.908 272.389C119.117 270.172 124.84 262.108 120.07 262.363C116.254 262.567 110.401 255.869 101.742 254.281C102.213 251.972 103.042 247.21 103.042 247.21L127.553 255.564Z",
    fill: "#CCCBEC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7042 265.486C69.8221 266.453 82.1409 265.101 93.2317 266.057C95.7021 270.172 93.4071 275.051 93.6451 277.799C93.8831 280.546 94.0847 282.048 103.99 285.973C113.894 289.899 113.287 288.693 114.203 288.815C115.12 288.938 113.985 292.106 113.359 291.858C112.734 291.61 69.4845 275.341 65.2511 273.542C61.0177 271.744 60.579 264.936 64.7042 265.486Z",
    fill: "#3C3A82"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.393 60.5221C164.066 62.3444 162.502 68.7233 162.219 70.1373H171.621C175.31 65.6126 171.651 61.6532 175.339 61.936C179.028 62.2188 175.623 58.5424 178.177 59.108C180.73 59.6736 178.531 55.1462 179.382 55.9946C180.801 57.4086 182.905 57.5997 183.567 57.4112C182.622 56.3742 180.219 53.9044 178.177 52.3208C175.623 50.3413 174.772 53.4519 172.786 51.7552C170.232 49.7756 169.381 52.8864 167.962 52.3208C166.543 51.7552 161.804 56.2235 163.393 60.5221Z",
    fill: "#FFA24C",
    stroke: "#FFA24C",
    strokeWidth: 0.288628
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.393 60.5221C164.066 62.3444 162.502 68.7233 162.219 70.1373H171.621C171.939 69.7475 172.202 69.3619 172.421 68.9828H163.219C163.624 67.0945 164.162 63.2822 163.652 61.0456C162.467 55.8503 166.249 52.0548 167.837 52.531C169.28 52.964 170.723 50.0777 172.599 51.9538C174.042 53.3969 176.64 50.9436 178.083 52.531C179.018 53.5597 182.124 56.1811 183.496 57.4289C183.521 57.4234 183.545 57.4175 183.567 57.4112C182.622 56.3742 180.219 53.9044 178.177 52.3208C175.623 50.3413 174.772 53.4519 172.786 51.7552C170.232 49.7756 169.381 52.8864 167.962 52.3208C166.543 51.7552 161.804 56.2235 163.393 60.5221Z",
    fill: "#F1A089",
    stroke: "#FFA24C",
    strokeWidth: 0.288628
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.217 59.1686L174.764 57.0039",
    stroke: "#FFA24C",
    strokeWidth: 0.288628
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.382 55.8494L177.506 54.4062",
    stroke: "#FFA24C",
    strokeWidth: 0.288628
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M173.214 94.4821C177.218 78.9399 181.547 64.2199 183.781 63.5801L183.785 63.5887C188.629 73.4522 197.093 90.686 190.121 104.207C181.404 121.114 157.12 130.095 154.743 112.66C152.841 98.7126 155.137 94.0929 157.917 69.92H172.882C173.146 77.5807 173.214 86.4443 173.214 94.4821Z",
    fill: "#02005B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M172.882 71.6523H157.629",
    stroke: "white",
    strokeWidth: 0.577256
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M173.21 91.2057C173.213 92.3092 173.214 93.4026 173.214 94.4812C173.572 93.091 173.933 91.7074 174.295 90.3398C173.933 94.6212 172.597 103.934 170.146 106.936C171.878 103.819 172.911 95.1503 173.21 91.2057Z",
    fill: "#3C3A82"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.652 106.503C167.115 107.369 171.185 108.45 173.227 109.822C172.584 111.234 174.01 117.68 173.227 119.923C164.461 118.351 166.322 113.43 164.461 114.806C161.613 116.91 159.129 117.45 157.013 118.351C150.519 118.351 150.375 118.481 147.921 118.481C150.375 111.987 159.57 105.482 163.652 106.503Z",
    fill: "#FBCBB8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M173.229 119.923C164.462 118.351 166.324 113.43 164.462 114.806C161.614 116.91 159.13 117.45 157.015 118.351C156.765 118.351 156.525 118.351 156.293 118.351C164.665 115.768 164.462 111.987 165.241 113.863C168.358 118.712 170.965 119.155 171.879 118.77L171.591 108.948C172.218 109.225 172.774 109.517 173.229 109.822C172.585 111.234 174.011 117.68 173.229 119.923Z",
    fill: "#F1A089"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.663 118.269C152.828 115.882 154.416 114.151 157.446 112.274",
    stroke: "#F1A089",
    strokeWidth: 0.288628
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.846 49.844C187.706 55.3386 187.865 61.1149 187.336 63.3163C178.091 86.0342 205.476 65.4296 210.847 49.844C210.847 49.844 197.857 44.4489 197.279 42.4287C196.702 40.4086 193.412 44.5608 182.846 49.844Z",
    fill: "#FFA24C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.277 42.4287C196.7 40.4086 193.41 44.5608 182.844 49.844C185.299 52.9634 185.877 53.9736 186.742 56.5713C191.442 55.994 196.287 48.0763 197.855 43.1794C197.542 42.8979 197.339 42.6442 197.277 42.4287Z",
    fill: "#FFA24C"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M232.773 63.3077C238.452 74.666 247.654 124.349 253.378 140.287C235.943 142.84 191.827 148.536 186.332 147.69C182.625 123.387 181.138 64.6353 183.78 63.5788C185.101 63.0505 187.483 62.5146 187.483 62.5146C183.785 79.4211 204.124 59.0876 210.728 49.8421C217.596 49.0496 228.943 55.6471 232.773 63.3077Z",
    fill: "#02005B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M212.287 49.9316C204.927 62.5145 181.837 81.2478 186.31 62.7756",
    stroke: "white",
    strokeWidth: 0.577256
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M185.3 125.408L182.602 72.0117C182.132 83.9512 182.717 106.425 184.065 125.408H185.3Z",
    fill: "#3C3A82"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M203.339 103.04C200.799 103.271 189.918 105.638 183.135 106.215C183.417 113.371 183.621 119.271 184.118 126.131C215.262 131.759 239.562 130.316 239.562 122.956C237.541 62.1998 222.389 56.427 214.451 59.0246C193.959 65.9517 206.514 102.752 203.339 103.04Z",
    fill: "#3C3A82"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.26 52.7752C171.797 54.3238 169.682 31.6422 171.797 18.1699C178.136 18.4341 198.171 19.7439 200.015 27.4156C203.063 40.0954 195.789 50.3976 181.26 52.7752Z",
    fill: "#FFA24C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.797 18.1699C178.136 18.4341 198.171 19.7439 200.015 27.4156C201.481 33.512 200.56 39.0589 197.594 43.4395C196.612 41.5634 195.69 39.3987 196.411 38.2442C200.308 32.183 201.029 29.0081 197.133 27.565C193.236 26.1219 196.7 34.0591 195.257 34.0591C189.879 33.4819 190.206 25.256 186.598 27.4156C179.786 31.9141 173.411 31.41 171.074 30.5956C170.957 26.2209 171.219 21.8515 171.797 18.1699Z",
    fill: "#F1A089"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M166.304 24.519C164.708 13.9223 172.873 12.0261 177.535 12.4939C179.134 9.12566 184.621 5.67915 188.026 6.2149C196.073 7.4812 198.281 13.6797 198.976 16.4074C209.244 22.5015 203.253 32.675 200.872 35.3331C200.665 35.9222 199.706 40.2869 198.231 43.5317C196.478 41.9184 196.975 40.2204 196.748 38.9824C196.465 37.4348 198.391 36.6643 199.88 32.4305C201.37 28.1967 197.33 26.1551 195.459 27.3585C193.587 28.562 196.516 34.3499 194.675 33.7023C189.715 31.337 191.504 23.8989 185.522 27.3797C176.939 32.3739 167.356 31.5083 166.304 24.519Z",
    fill: "#05185A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M185.52 27.3826C176.937 32.3768 167.354 31.5111 166.302 24.5219C165.714 20.6153 166.452 17.8911 167.852 16.032C166.008 28.0467 178.862 28.6052 185.52 27.3826Z",
    fill: "#312E63"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M239.348 193.015C269.001 185.982 260.918 155.788 253.169 141.137C212.543 142.602 129.425 137.099 132.547 158.941C133.803 167.731 143.923 255.977 145.18 265.396C157.737 260.054 190.207 256.158 194.826 249.231C190.063 234.944 176.93 210.555 169.858 188.763C192.227 190.206 219.747 197.536 239.348 193.015Z",
    fill: "#7372B8",
    stroke: "#3C3A82",
    strokeWidth: 0.288628
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M253.168 141.137C260.534 155.066 268.204 183.046 243.458 191.812C223.542 192.696 167.693 185.011 164.951 185.011C165.961 189.629 187.897 244.035 190.206 247.643C186.742 251.973 155.426 255.148 144.7 261.064",
    stroke: "#3C3A82",
    strokeWidth: 0.577256
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M239.346 193.015C268.999 185.982 260.916 155.788 253.168 141.137C212.541 142.602 129.423 137.099 132.545 158.941C133.801 167.731 143.49 252.8 144.747 262.219L154.993 186.166L170.431 190.495C170.236 189.918 170.044 189.341 169.856 188.763C192.225 190.206 219.745 197.536 239.346 193.015Z",
    fill: "#3C3A82",
    stroke: "#3C3A82",
    strokeWidth: 0.288628
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M239.366 193.565C269.551 189.564 260.916 155.781 253.175 141.137C189.628 141.137 154.733 140.435 137.964 146.336C130.172 149.078 122.234 156.293 94.2375 250.242C93.7677 251.818 104.485 251.54 114.874 257.89C125.264 264.24 137.046 269.158 142.55 268.293C142.55 268.293 149.51 209.834 152.974 182.991C178.468 190.426 212.43 197.134 239.366 193.565Z",
    fill: "#7372B8",
    stroke: "#3C3A82",
    strokeWidth: 0.288628
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7068 245.046C101.134 246.826 112.913 251.194 116.607 254.426C120.301 257.659 133.155 261.738 139.12 263.374L150.809 177.363C164.244 182.895 200.764 193.295 239.367 190.64C266.549 188.77 259.766 157.736 249.953 141.137",
    stroke: "#3C3A82",
    strokeWidth: 0.577256
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M152.974 182.991C152.819 184.19 152.658 185.443 152.493 186.743C151.093 181.837 148.975 169.714 143.16 161.488C148.788 166.972 152.107 176.487 154.705 183.491C154.124 183.325 153.547 183.158 152.974 182.991Z",
    fill: "#3C3A82",
    stroke: "#3C3A82",
    strokeWidth: 0.288628
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M223.935 60.7703C209.256 51.8373 203.429 69.4142 204.387 78.7334C205.178 86.4331 209.4 105.043 208.177 105.145C205.641 105.356 186.887 106.359 172.779 107.092V121.978C225.419 131.758 237.602 127.429 237.602 119.943C237.602 114.653 236.243 68.2602 223.935 60.7703Z",
    fill: "#02005B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M174.799 122.266C174.799 117.406 174.799 110.702 174.799 107.092",
    stroke: "white",
    strokeWidth: 0.577256
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M171.654 195.08L170.356 190.462H202.618C210.977 188.058 211.583 181.438 213.351 175.894C222.382 147.58 229.755 136.963 250.829 133.929C262.067 132.311 270.321 129.21 273.043 127.861C262.402 196.901 253.138 195.107 244.161 195.107C236.535 195.107 226.414 195.08 171.654 195.08Z",
    fill: "#181818"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M282.146 189.611C277.045 190.789 265.743 189.376 261.348 174.307C270.373 175.091 284.108 175.484 282.146 189.611Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M291.172 236.31C290.387 218.259 292.428 188.827 270.766 180.979",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M290.698 182.242C288.66 174.725 282.908 166.24 275.475 190.398C282.538 191.575 314.947 187.821 290.698 182.242Z",
    fill: "#FFA24C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M290.779 182.549C290.753 182.447 290.726 182.345 290.698 182.242M290.698 182.242C288.66 174.725 282.908 166.24 275.475 190.398C282.538 191.575 314.947 187.821 290.698 182.242Z",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M279.539 173.397C274.603 176.536 262.121 177.402 251.684 155.754C262.304 155.448 285.307 156.628 279.539 173.397Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M293.133 167.637C289.471 171.299 280.576 170.462 274.297 137.812C288.817 142.522 308.83 154.294 293.133 167.637Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M302.551 175.876C296.272 171.691 289.68 160.572 313.539 149.584C315.11 159.395 317.462 182.548 302.551 175.876Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M303.335 162.927C298.495 154.555 298.312 136.399 336.299 130.748C330.021 137.812 306.473 168.028 303.335 162.927Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M313.541 173.129C308.832 168.551 307.34 158.296 339.048 153.9C333.947 161.356 321.39 179.408 313.541 173.129Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M308.438 195.892C310.4 189.09 318.719 177.918 336.3 189.22C330.021 190.398 325.312 189.613 308.438 195.892Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M293.526 235.526C293.918 217.998 293.918 182.863 290.779 182.549C287.953 183.805 285.416 185.427 284.5 186.081",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M296.667 235.133C294.967 213.811 292.349 157.433 316.682 145.268",
    stroke: "#FFA24C",
    strokeWidth: 0.288628
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M322.173 163.32C306.162 168.971 304.514 213.812 305.692 235.527H306.868C305.807 209.627 307.261 170.384 322.173 163.32Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M314.327 190.004C302.944 195.498 300.853 223.622 300.984 235.525H301.769C302.553 200.599 308.438 194.321 314.327 190.004Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M262.525 159.787C287.641 169.205 286.856 202.169 286.856 235.525H289.21C288.425 207.271 290.388 169.205 262.525 159.787Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.88 234.742C295.88 209.862 297.426 160.034 284.824 149.431C284.103 148.852 283.342 148.378 282.537 148.016C283.347 148.353 284.108 148.829 284.824 149.431C298.158 160.136 297.49 206.446 298.234 234.742H295.88Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M305.689 163.711C297.45 171.952 300.457 217.473 300.195 236.31H301.765C301.896 220.089 299.02 170.382 305.689 163.711Z",
    fill: "#FFA24C",
    stroke: "#FDCBB4",
    strokeWidth: 0.288628
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M318.64 232.387H275.865L284.891 291.643H310.399L318.64 232.387Z",
    fill: "#9B9B9B",
    stroke: "#D7D7D7",
    strokeWidth: 0.288628
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M275.865 232.387H318.64L318.039 236.703L317.439 241.02L316.729 246.122L316.075 250.831L315.42 255.54L314.71 260.641L313.946 266.135L313.182 271.629L312.418 277.123L311.818 281.44L311.108 286.541L310.399 291.643H284.891L284.114 286.541L283.337 281.44L282.679 277.123L281.843 271.629L281.006 266.135L280.169 260.641L279.392 255.54L278.675 250.831L277.957 246.122L277.18 241.02L276.523 236.703L275.865 232.387Z",
    fill: "#9B9B9B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M276.523 236.703L275.865 232.387H318.64L318.039 236.703M276.523 236.703H318.039M276.523 236.703L277.18 241.02M318.039 236.703L317.439 241.02M277.18 241.02H317.439M277.18 241.02L277.957 246.122M317.439 241.02L316.729 246.122M277.957 246.122H316.729M277.957 246.122L278.675 250.831M316.729 246.122L316.075 250.831M278.675 250.831H316.075M278.675 250.831L279.392 255.54M316.075 250.831L315.42 255.54M279.392 255.54H315.42M279.392 255.54L280.169 260.641M315.42 255.54L314.71 260.641M280.169 260.641H314.71M280.169 260.641L281.006 266.135M314.71 260.641L313.946 266.135M281.006 266.135H313.946M281.006 266.135L281.843 271.629M313.946 266.135L313.182 271.629M281.843 271.629H313.182M281.843 271.629L282.679 277.123M313.182 271.629L312.418 277.123M282.679 277.123H312.418M282.679 277.123L283.337 281.44M312.418 277.123L311.818 281.44M283.337 281.44H311.818M283.337 281.44L284.114 286.541M311.818 281.44L311.108 286.541M284.114 286.541L284.891 291.643H310.399L311.108 286.541M284.114 286.541H311.108",
    stroke: "#D7D7D7",
    strokeWidth: 0.288628
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 291.514H342.313",
    stroke: "#232056",
    strokeWidth: 0.288628
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 256.158,
    y: 8.80252,
    width: 62.8247,
    height: 48.2009,
    fill: "#FDF2D6",
    stroke: "#CCCBEC",
    strokeWidth: 0.288628
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M275.692 41.1395L256.459 56.8072H318.683L294.925 34.6113L280.783 48.103L275.692 41.1395Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.023,
    cy: 26.7454,
    r: 6.92707,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration2);
export default __webpack_public_path__ + "static/media/Illustration_2.a389f286156b27c7df7dbd8368a8db4e.svg";
export { ForwardRef as ReactComponent };